/**
 * @file EmojiList component
 * @author malcolmmzma
 */

import React, { useState } from 'react';
import LottieIcon from '@tencent/od-lottie-icon';
import { Flex, Text } from '@tencent/odc';
import { EMOJI_DATA } from './constants';
import classNames from 'classnames';

export interface EmojiListProps {
  className?: string; // 自定义类名
  style?: React.CSSProperties; // 自定义样式
  emojiSize?: number; // 表情大小
  value?: number; // 当前选中的表情值
  defaultValue?: number; // 默认选中的表情值
  feedback?: {
    message?: string; // 反馈消息
    status?: 'normal' | 'error'; // 反馈状态
  };
  onSelect?: (value: number) => void; // 选中表情时的回调
  onDeselect?: (value: number) => void; // 取消
  onChange?: (value: number) => void; // 选中表情时的回调
}

const EmojiList = (props: EmojiListProps) => {
  const {
    className,
    style = {},
    emojiSize = 60,
    value,
    defaultValue,
    onSelect,
    onDeselect,
    onChange,
    feedback,
  } = props;
  const [selectedValue, setSelectedValue] = useState(value || defaultValue);

  const handleSelect = (val: number) => {
    setSelectedValue(val);
    onSelect?.(val);
  };

  const handleDeselect = (val: number) => {
    setSelectedValue(undefined);
    onDeselect?.(val);
  };
  const setVal = (val: number) => {
    if (selectedValue === val) {
      handleDeselect(val);
    } else {
      handleSelect(val);
    }
    onChange?.(val);
  };

  return (
    <div>
      <div
        className={className}
        style={{
          display: 'flex',
          gap: 16,
          flexWrap: 'wrap',
          ...style,
        }}
      >
        {EMOJI_DATA.map((item) => {
          const { lottieURL, value, label } = item;
          const active = value === selectedValue;
          return (
            <Flex column bothCenter gap={2} onClick={() => setVal(value)} key={value}>
              <LottieIcon path={lottieURL} width={emojiSize} height={emojiSize} active={active} />
              <span
                className={classNames({
                  'tw-text-blue-06 tw-font-semibold': active,
                  'tw-text-text-secondary': !active,
                })}
              >
                {label}
              </span>
            </Flex>
          );
        })}
      </div>
      {feedback?.message && (
        <Text size="small" type={feedback?.status === 'error' ? 'danger' : 'comment'}>
          {feedback?.message}
        </Text>
      )}
    </div>
  );
};

export default EmojiList;
